import {combine, merge, sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';

import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    createCustomsUserFx,
    customsList$,
    customsUserIdForRemoveConfirmation$,
    data$,
    defaultFilters,
    defaultSortings,
    fetchCustomsListFx,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    onChangeCustomsUserIdForRemoveConfirmation,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    removeCustomsUserFx,
    search$,
    searchChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateChanged,
} from './index';

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

data$.on(fetchDataFx.doneData, (_, data) => data).reset(Gate.close);
customsUserIdForRemoveConfirmation$
    .on(onChangeCustomsUserIdForRemoveConfirmation, (_, payload) => payload)
    .reset(Gate.close);
pageNumber$.reset(Gate.close);
pageSize$.reset(Gate.close);
customsList$
    .on(fetchCustomsListFx.doneData, (_, data) =>
        data.map((c) => ({
            label: c.name,
            value: c.name,
            text: c.address,
        })),
    )
    .reset(Gate.close);

sample({
    clock: Gate.open,
    target: fetchCustomsListFx,
});

sample({
    clock: merge([
        Gate.open,
        pageNumberChanged,
        pageSizeChanged,
        searchChanged,
        tableStateChanged,
        removeCustomsUserFx.done,
    ]),
    source: combine({
        sortings: sortings$,
        filters: filters$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        searchField: search$,
        state: Gate.state,
    }),
    fn: ({state, sortings, filters, pageNumber, pageSize, searchField}) => ({
        paging: {pageSize, pageNumber},
        sortings: mapSortings(sortings),
        filters: mapFilters(filters),
        searchField,
        id: state.id,
    }),
    target: fetchDataFx,
});

createCustomsUserFx.doneData.watch(() =>
    toast.success(i18next.t('pages.register.message.success')),
);
removeCustomsUserFx.doneData.watch(() => toast.success(i18next.t('pages.register.message.remove')));

[fetchDataFx, createCustomsUserFx, removeCustomsUserFx].forEach((fx) =>
    fx.failData.watch((err) => showRestError(err as RestError)),
);
